<template>
  <v-app>
    <app-bar ></app-bar>
    <router-view />
  <Footer/>
  </v-app>
</template>

<script>
import AppBar from "@/components/AppBar.vue";
import Footer from "@/components/Footer.vue";
export default {
  components:{
    AppBar,
    Footer,
  },
  data() {
    return {};
  },
};
</script>
